export const TestIds = {
  colorUnderlay: 'colorUnderlay',
  mediaPadding: 'mediaPadding',
  canvas: 'canvas',
} as const;
